import React, { ReactNode } from "react";
import styles from "./PlanCard.module.scss";
import plan1GigImageD from "../../images/plan-1gig-d.jpg";
import plan2GigImageD from "../../images/plan-2gig-d.jpg";
import plan5GigImageD from "../../images/plan-5gig-d.jpg";
import { ROUTES } from "../../lib/constants";
import { Button } from "../Button/Button";
import { PlanType } from "../../lib/types";
import { Image } from "../Image/Image";

const PLAN_DATA: Record<PlanType, {
  image: string;
  imageDesc: string;
  packageUrl: string;
}> = {
  "1 Gig": {
    image: plan1GigImageD,
    imageDesc: "Mother with small child looking at laptop.",
    packageUrl: ROUTES.checkAvailability.path,
  },
  "2 Gigs": {
    image: plan2GigImageD,
    imageDesc: "Man with headphones looking at laptop while puppy is standing on desk.",
    packageUrl: ROUTES.checkAvailability.path,
  },
  "5 Gigs": {
    image: plan5GigImageD,
    imageDesc: "Senior couple sitting by swimmimg pool. Man looking at laptop. Woman looking at phone.",
    packageUrl: ROUTES.checkAvailability.path,
  },
};

export const PlanCard = (props: {
  className?: string;
  landing?: boolean;
  type: PlanType;
  children?: ReactNode;
  gigInternetLinkText: "Learn More" | "Compare Packages";
}): React.JSX.Element => {
  const { image, imageDesc, packageUrl } = PLAN_DATA[props.type];

  return (
    <div
      data-landing={props.landing || false}
      className={`${styles.card} ${
        styles["card__" + props.type.replace(" ", "").toLowerCase()]
      } ${props.className || ""}`}
    >
      <div className={styles.header}>
        <h3 className="headline__h3">
          {props.type === "1 Gig" && "Connect & Control"}
          {props.type === "2 Gigs" && "Work Hard, Play Hard"}
          {props.type === "5 Gigs" && "Everything & Everywhere"}
        </h3>

        <div className={styles.imageWrap}>
          <Image
            src={image}
            alt={imageDesc}
            width="100"
            height="100"
            loading="eager"
          />
        </div>

        <div className={styles.priceWrap}>
          <p className="headline__h4">{props.type}</p>
          <p className="headline__h4">
            {props.type === "1 Gig" && "$80"}
            {props.type === "2 Gigs" && "$95"}
            {props.type === "5 Gigs" && "$150"}
            <span> / month</span>
          </p>
        </div>
      </div>

      <div className={styles.body}>{props.children}</div>

      <div
        className={styles.footer}
        data-reverse={props.gigInternetLinkText === "Compare Packages"}
      >
        <Button
          seconday={true}
          path={ROUTES.gigInternet.path}
          target="_self"
          size="lg"
        >
          {props.gigInternetLinkText}
        </Button>

        <Button
          path={packageUrl}
          target="_self"
          size="lg"
          gradient={props.type === "2 Gigs" ? "orange" : undefined}
        >
          Select Package
        </Button>
      </div>
    </div>
  );
};
